import { Action } from '@ngrx/store';
import { CalendarFiltersState } from '../calendar-filter/state';
export enum PendoTrackingActionTypes {
  DealCalendarExport = '[PendoTracking] Deal Calendar Export',
  DealShowExport = '[PendoTracking] Deal Show Export',
  DealMonitorExport = '[PendoTracking] Deal Monitor Export',
  DealManagerExport = '[PendoTracking] Deal Manager Export',
  BidCompExport = '[PendoTracking] BidComp Export',
  DealShowTabActivated = '[PendoTracking] Deal Show Tab Activated',
  DealShowBidResultsOpened = '[PendoTracking] Deal Show Bid Results Opened',
  DealShowPrint = '[PendoTracking] Deal Show Print',
  DealShowLoaded = '[PendoTracking] Deal Show Loaded',
  DealCalendarWeekChange = '[PendoTracking] Deal Calendar Week Change',
  DealCalendarFilterSetSaved = '[PendoTracking] Deal Calendar Filter Set Saved'
}

export class PendoDealCalendarExport implements Action {
  public readonly type = PendoTrackingActionTypes.DealCalendarExport;

  constructor(public weekOf: string) {}
}

export class PendoDealShowExport implements Action {
  public readonly type = PendoTrackingActionTypes.DealShowExport;

  constructor(public dealId: string) {}
}

export class PendoDealMonitorExport implements Action {
  public readonly type = PendoTrackingActionTypes.DealMonitorExport;
}
export class PendoDealManagerExport implements Action {
  public readonly type = PendoTrackingActionTypes.DealManagerExport;
}

export class PendoBidCompExport implements Action {
  public readonly type = PendoTrackingActionTypes.BidCompExport;
}

export class PendoDealShowTabActivated implements Action {
  public readonly type = PendoTrackingActionTypes.DealShowTabActivated;
  constructor(public payload: { tabName: string; dealId: string }) {}
}

export class PendoDealShowBidResultsOpened implements Action {
  public readonly type = PendoTrackingActionTypes.DealShowBidResultsOpened;
}

export class PendoDealShowLoaded implements Action {
  public readonly type = PendoTrackingActionTypes.DealShowLoaded;
  constructor(public dealId: string) {}
}
export class PendoDealShowPrint implements Action {
  public readonly type = PendoTrackingActionTypes.DealShowPrint;
}

export class PendoDealCalendarWeekChange implements Action {
  public readonly type = PendoTrackingActionTypes.DealCalendarWeekChange;

  constructor(public weekOf: string) {}
}

export class PendoDealCalendarFilterSetSaved implements Action {
  public readonly type = PendoTrackingActionTypes.DealCalendarFilterSetSaved;
  constructor(
    public payload: { name: string; filters: Partial<CalendarFiltersState> }
  ) {}
}
